module.exports = __webpack_public_path__ + "img/logo-light.b2f5a644.svg";